import { ReactNode } from 'react';
import { useLocation } from 'react-router';

import { AuthenticatedRoute } from '@/app/constant';
import { Navigation } from '@/components/ui/Navigation';
import { TopNavBar } from '@/sections/topNavBar/TopNavBar';
import { cn } from '@/utils/classname';

export function Body({ children }: { children?: ReactNode }) {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const routePath = pathSegments.slice(2).join('/'); // Get everything after userId

  const isCustomerManagement = routePath.includes(
    AuthenticatedRoute.CUSTOMER_MANAGEMENT
  );

  const hideNavigation = isCustomerManagement;

  return (
    <div className="relative flex size-full overflow-hidden">
      {!hideNavigation && <Navigation />}
      <div className="flex size-full flex-col overflow-hidden">
        <TopNavBar />
        <div className={cn('flex size-full flex-col overflow-auto px-9 py-4')}>
          {children}
        </div>
      </div>
    </div>
  );
}
